import Product, { PRODUCT_REFERRED_FROM } from '@common/models/Product';
import {
  addProductToCart,
  CartSliceType,
  removeProductFromCart,
  subtractProductFromCart,
} from '@common/store/cart/slice';
import { RecentlyViewedTime } from '@common/store/recentlyViewed/slice';
import { StoreInfoSliceType } from '@common/store/storeInfo/slice';
import { isMobile } from '@common/utils';
import ProductCard from '@components/ProductCard';
// import MArrow from '@images/left.svg';
import Arrow from '@images/testLeft.svg';
// import Rupee from '@components/Rupee';
import Link from '@lib/Link';
import classnames from 'classnames';
import React, { useState } from 'react';

interface RecentlyViewedProps {
  products: Array<Product> | Record<number, Product & RecentlyViewedTime>;
  referredFrom?: PRODUCT_REFERRED_FROM;
  title?: string;
  ignoreProducts?: Set<number>;
  cart: CartSliceType;
  addProductToCart: typeof addProductToCart;
  subtractProductFromCart: typeof subtractProductFromCart;
  removeProductFromCart: typeof removeProductFromCart;
  storeInfo: StoreInfoSliceType;
}

const RecentlyViewed: React.FunctionComponent<RecentlyViewedProps> = ({
  products,
  ignoreProducts = new Set(),
  title = 'Recently Viewed',
  referredFrom,
}) => {
  const filteredProducts = (Array.isArray(products) ? [...products] : Object.values(products))
    .reverse()
    .filter((product) => !ignoreProducts.has(product.id));

  const [LeftArrow, SetLeftArrow] = useState(false);
  const [RightArrow, SetRightArrow] = useState(true);

  if (!filteredProducts.length) {
    return null;
  }
  let arrowshow = 0;
  isMobile() ? (arrowshow = 2) : (arrowshow = 3);
  return (
    <div className="">
      <div className={classnames('flex flex-col flex-no-wrap ')}>
        <div className="flex justify-center items-center mb-44">
          <div
            className="flex flex-col justify-center items-center text-esteem-heading1 text-28 md:text-34 font-prata leading-28 md:leading-50 capitalize"
            font-customisation="section-heading"
            color-customisation="page-heading"
          >
            <div>
              {title}
              {/* <div
                className={classnames('w-full bg-essense-bgHeading h-7  -mt-14 z-auto opacity-70 hidden md:flex', {})}
              ></div> */}
            </div>
          </div>
          {/* <div>
            {filteredProducts.length > arrowshow && !isMobile() && (
              <div className="flex items-center gap-10">
                <div className="pointer-events-none">
                  <button
                    className={classnames(
                      'md:mt-0 rounded-full focus:outline-none text-carouselArrow-enabled pointer-events-auto',
                      {
                        'opacity-50': !LeftArrow,
                      },
                    )}
                    onClick={() => {
                      document.getElementById('RecentlyViewed').scrollBy({
                        top: 0,
                        left: isMobile() ? -200 : -800,
                        behavior: 'smooth',
                      });
                    }}
                  >
                    <img src={Arrow} className="fill-current transform -rotate-90" />
                  </button>
                </div>
                <div className="pointer-events-none">
                  <button
                    className={classnames(
                      'md:mt-0 rounded-full focus:outline-none text-carouselArrow-enabled pointer-events-auto',
                      {
                        'opacity-50': !RightArrow,
                      },
                    )}
                    onClick={() => {
                      document.getElementById('RecentlyViewed').scrollBy({
                        top: 0,
                        left: isMobile() ? +200 : +800,
                        behavior: 'smooth',
                      });
                    }}
                  >
                    <img src={Arrow} className=" fill-current transform rotate-90" />
                  </button>
                </div>
              </div>
            )}
          </div> */}
        </div>
        <div
          className="flex overflow-x-auto hideScroll"
          id="RecentlyViewed"
          onScroll={() => {
            const ele = document.getElementById('RecentlyViewed');
            if (ele.scrollLeft > 50) SetLeftArrow(true);
            else SetLeftArrow(false);
            if (ele.scrollWidth - ele.scrollLeft === ele.clientWidth) SetRightArrow(false);
            else SetRightArrow(true);
          }}
        >
          {filteredProducts.map((product) => (
            <div className="ml-32 first:ml-0 justify-between items-center" key={product.id}>
              <Link key={product.id} to={product.storeLink} className="flex">
                <ProductCard
                  product={product}
                  addProductToCart={addProductToCart}
                  subtractProductFromCart={subtractProductFromCart}
                  hideQuickView
                  referredFrom={referredFrom}
                  // cartProductQuantity={cart.quantityByProductId[product.id] || 0}
                  // addToast={addToast}
                  // storeInfo={storeInfo}
                />
              </Link>
            </div>
          ))}
        </div>
      </div>
      {filteredProducts?.length > arrowshow && (
        <div className="relative block  ">
          <div className=" absolute left-0 top-0 h-full flex items-center mt-265N md:-mt-300 ml-18 md:-ml-32 pointer-events-none">
            <button
              className={classnames('z-40 -ml-90 -mt-26 md:mt-0 rounded-full focus:outline-none pointer-events-auto', {
                'opcaity-50': !LeftArrow,
              })}
              onClick={() => {
                document.getElementById('RecentlyViewed').scrollBy({
                  top: 0,
                  left: isMobile() ? -300 : -1250,
                  behavior: 'smooth',
                });
              }}
            >
              <img
                src={Arrow}
                className="fill-current transform -rotate-180 min-w-24 min-h-47 w-24 h-47 hidden md:flex"
              />
              <img
                src={Arrow}
                className=" fill-current transform rotate-180 min-w-24 min-h-47 w-24 h-47 flex md:hidden"
              />
            </button>
          </div>
          {RightArrow && (
            <div className=" absolute right-30 top-0 h-full flex items-center mt-265N md:-mt-300 mr-18 md:-mr-32 pointer-events-none">
              <button
                className={classnames(
                  'z-40 -mr-26 md:-mr-90 -mt-26 md:mt-0 rounded-full focus:outline-none  pointer-events-auto',
                  {
                    'opacity-50': !RightArrow,
                  },
                )}
                onClick={() => {
                  document.getElementById('RecentlyViewed').scrollBy({
                    top: 0,
                    left: isMobile() ? +300 : +1250,
                    behavior: 'smooth',
                  });
                }}
              >
                <img src={Arrow} className=" fill-current min-w-24 min-h-47 w-24 h-47 hidden md:flex" />
                <img src={Arrow} className=" fill-current min-w-24 min-h-47 w-24 h-47 flex md:hidden" />
              </button>
            </div>
          )}
        </div>
      )}
      <div id="Review"></div>
    </div>
  );
};

export default RecentlyViewed;
